<div class="landing-page-wrapper dash-page-wrap">
    <div class="slider-outer-block">
        <div class="navigation-wrapper">
            <div class="keen-slider keen-slider--vertical" #sliderRef>
                <div class="keen-slider__slide number-slide1">
                    <div class="bg-img">
                        <img src="./assets/images/landing-hero-bg.webp" alt="Image" />
                    </div>
                    <div class="slider-content-block">
                        <div>
                            <h1 class="slider-title">Cotogna</h1>
                            <h6 class="slider-info">Italian Restaurant</h6>
                        </div>
                        <button class="btn btn-primary border-white" title="Go to Restaurant">
                            Go to Restaurant
                        </button>
                    </div>
                </div>
                <div class="keen-slider__slide number-slide2">
                    <div class="bg-img">
                        <img src="./assets/images/landing-hero-bg-2.webp" alt="Image" />
                    </div>
                    <div class="slider-content-block">
                        <div>
                            <h1 class="slider-title">Cotogna</h1>
                            <h6 class="slider-info">Italian Restaurant</h6>
                        </div>
                        <button class="btn btn-primary border-white" title="Go to Restaurant">
                            Go to Restaurant
                        </button>
                    </div>
                </div>
                <div class="keen-slider__slide number-slide3">
                    <div class="bg-img">
                        <img src="./assets/images/landing-hero-bg.webp" alt="Image" />
                    </div>
                    <div class="slider-content-block">
                        <div>
                            <h1 class="slider-title">Cotogna</h1>
                            <h6 class="slider-info">Italian Restaurant</h6>
                        </div>
                        <button class="btn btn-primary border-white" title="Go to Restaurant">
                            Go to Restaurant
                        </button>
                    </div>
                </div>
                <div class="keen-slider__slide number-slide4">
                    <div class="bg-img">
                        <img src="./assets/images/landing-hero-bg-2.webp" alt="Image" />
                    </div>
                    <div class="slider-content-block">
                        <div>
                            <h1 class="slider-title">Cotogna</h1>
                            <h6 class="slider-info">Italian Restaurant</h6>
                        </div>
                        <button class="btn btn-primary border-white" title="Go to Restaurant">
                            Go to Restaurant
                        </button>
                    </div>
                </div>
            </div>
            <!-- slider skeleton start -->
            <!-- <div style="background-color: transparent;box-shadow: none;border: 0;" class="slider-skeleton">
                <div class="item">
                    <div class="d-flex" style="height: 100%;">
                        <div style="width: 100%;">
                            <ngx-skeleton-loader [theme]="{height: '100%'}" />
                        </div>
                    </div>
                </div>
            </div> -->
        </div>
        <div class="dots">
            <button (click)="slider.moveToIdx(i)" *ngFor="let slide of dotHelper; let i = index"
                [class]="'dot ' + (i === currentSlide ? 'active' : '')"></button>
        </div>
    </div>
    <div class="container landing-container">
        <div class="row flex-grow-1">
            <div class="col-lg-auto order-1 order-lg-0 food-block-row">
                <span class="food-spacing-block"></span>
                <div class="aside-col-wrap">
                    <div class="food-news">
                        <h4 class="block-title food-news-block-title">Foodie News</h4>
                        <ul>
                            <div style="background-color: transparent;box-shadow: none;border: 0;">
                                <div class="item">
                                    <div class="d-flex" style="gap: 16px;">
                                        <div style="width: 20%;">
                                            <ngx-skeleton-loader [theme]="{height: '45px', borderRadius: '10px'}" />
                                        </div>
                                        <div style="width: 80%;">
                                            <ngx-skeleton-loader [theme]="{height: '16px', width:'80%'}" />
                                            <ngx-skeleton-loader [theme]="{height: '16px'}" />
                                            <div style="width: 30%;">
                                                <ngx-skeleton-loader [theme]="{height: '16px'}" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ul>
                        <ul class="food-news-ul">
                            <li>
                                <div class="img-wrap">
                                    <img src="./assets/images/food-news-1.jpg" alt="Image" />
                                </div>
                                <div>
                                    <p class="date">Apr 20, 6:15 PM</p>
                                    <h5 class="news-text">I don't need to drink</h5>
                                    <h6 class="news-info">
                                        Lifetime value to customer acquisition...
                                    </h6>
                                    <div class="btn-grps">
                                        <button class="btn-chips btn-primary-light">Drinks</button>
                                        <button class="btn-chips btn-primary-light">Breakfast</button>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div class="img-wrap">
                                    <img src="./assets/images/food-news-2.jpg" alt="Image" />
                                </div>
                                <div>
                                    <p class="date">Apr 20, 3:15 AM</p>
                                    <h5 class="news-text">Bow ties are cool!</h5>
                                    <h6 class="news-info">
                                        Lifetime value to customer acquisition
                                    </h6>
                                    <div class="btn-grps">
                                        <button class="btn-chips btn-primary-light">Breakfast</button>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div class="img-wrap">
                                    <img src="./assets/images/food-news-3.jpg" alt="Image" />
                                </div>
                                <div>
                                    <p class="date">Apr 20, 1:25 PM</p>
                                    <h5 class="news-text">Yo Yogurt!</h5>
                                    <h6 class="news-info">
                                        Lifetime value to customer acquisition
                                    </h6>

                                    <div class="btn-grps">
                                        <button class="btn-chips btn-primary-light">Healthy</button>
                                        <button class="btn-chips btn-primary-light">Lunch</button>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div class="img-wrap">
                                    <img src="./assets/images/food-news-4.jpg" alt="Image" />
                                </div>
                                <div>
                                    <p class="date">Apr 19, 3:00 PM</p>
                                    <h5 class="news-text">Some good news here</h5>
                                    <h6 class="news-info">
                                        Lifetime value to customer acquisition
                                    </h6>
                                    <div class="btn-grps">
                                        <button class="btn-chips btn-primary-light">Lunch</button>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div class="img-wrap">
                                    <img src="./assets/images/food-news-1.jpg" alt="Image" />
                                </div>
                                <div>
                                    <p class="date">Apr 20, 6:15 PM</p>
                                    <h5 class="news-text">I don't need to drink</h5>
                                    <h6 class="news-info">
                                        Lifetime value to customer acquisition
                                    </h6>
                                    <div class="btn-grps">
                                        <button class="btn-chips btn-primary-light">Drinks</button>
                                        <button class="btn-chips btn-primary-light">Breakfast</button>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="deals-of-the-day">
                        <h4 class="block-title deals-of-the-day-block-title">
                            Deals and Offers
                            <span class="day-text">Today</span>
                        </h4>
                        <ul>
                            <div style="background-color: transparent;box-shadow: none;border: 0;">
                                <div class="item">
                                    <div class="d-flex" style="gap: 16px;">
                                        <div style="width: 20%; margin-top: 12px;">
                                            <ngx-skeleton-loader [theme]="{height: '20px', borderRadius: '4px'}" />
                                        </div>
                                        <div style="width: 80%;">
                                            <ngx-skeleton-loader [theme]="{height: '16px', width:'80%'}" />
                                            <ngx-skeleton-loader [theme]="{height: '16px'}" />
                                            <div style="width: 40%;">
                                                <ngx-skeleton-loader [theme]="{height: '16px'}" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ul>
                        <ul class="deals-of-the-day-ul">
                            <li class="offer">
                                <div class="chip-wrap">
                                    <button class="btn-chips btn-success-light">Offer</button>
                                </div>
                                <div>
                                    <h5 class="deal-text">Thursday Salad</h5>
                                    <p class="deal-info">Thursday special deal salad $2,9</p>
                                    <div class="time-wrap">
                                        <div class="svg-wrap">
                                            <svg width="12" height="12" viewBox="0 0 12 12" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M6 0C2.6916 0 0 2.6916 0 6C0 9.3084 2.6916 12 6 12C9.3084 12 12 9.3084 12 6C12 2.6916 9.3084 0 6 0ZM9.45 6.6H5.4V2.4H6.6V5.4H9.45V6.6Z"
                                                    fill="currentcolor" />
                                            </svg>
                                        </div>
                                        9 AM - 11 PM
                                    </div>
                                </div>
                            </li>
                            <li class="deal">
                                <div class="chip-wrap">
                                    <button class="btn-chips btn-blue-light">Deal</button>
                                </div>
                                <div>
                                    <h5 class="deal-text">Pasta Special</h5>
                                    <p class="deal-info">Thursday special deal salad $2,9</p>
                                    <div class="time-wrap">
                                        <div class="svg-wrap">
                                            <svg width="12" height="12" viewBox="0 0 12 12" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M6 0C2.6916 0 0 2.6916 0 6C0 9.3084 2.6916 12 6 12C9.3084 12 12 9.3084 12 6C12 2.6916 9.3084 0 6 0ZM9.45 6.6H5.4V2.4H6.6V5.4H9.45V6.6Z"
                                                    fill="currentcolor" />
                                            </svg>
                                        </div>
                                        9 AM - 11 PM
                                    </div>
                                </div>
                            </li>
                            <li class="deal">
                                <div class="chip-wrap">
                                    <button class="btn-chips btn-blue-light">Deal</button>
                                </div>
                                <div>
                                    <h5 class="deal-text">Cocktails</h5>
                                    <p class="deal-info">Thursday special deal salad $2,9</p>
                                    <div class="time-wrap">
                                        <div class="svg-wrap">
                                            <svg width="12" height="12" viewBox="0 0 12 12" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M6 0C2.6916 0 0 2.6916 0 6C0 9.3084 2.6916 12 6 12C9.3084 12 12 9.3084 12 6C12 2.6916 9.3084 0 6 0ZM9.45 6.6H5.4V2.4H6.6V5.4H9.45V6.6Z"
                                                    fill="currentcolor" />
                                            </svg>
                                        </div>
                                        9 AM - 11 PM
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="col-lg order-0 order-lg-1">
                <div class="cards-showcase-wrap">
                    <div class="location-finder-wrap for-dashboard-only article-filter-btn-visible">
                        <div class="search-wrap" [class.view-searchbar]="isSearchBarActive">
                            <div class="form-group">
                                <!-- <div class="location-chip d-none d-md-flex">
                                    <img src="./assets/images/ic-location.svg" alt="Icon">
                                    <h6>Sydney</h6>
                                </div> -->
                                <input class="form-control main-input" type="search" placeholder="Search"
                                    aria-label="Search" />
                                <div class="btn-grps top-layer">
                                    <button class="btn btn-clear-search d-none">
                                        <svg width="10" height="10" viewBox="0 0 10 10" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M1.06698 0.183065C0.822892 -0.0610214 0.427151 -0.0610215 0.183065 0.183064C-0.0610214 0.42715 -0.0610215 0.822892 0.183064 1.06698L4.1163 5.00021L0.18349 8.93302C-0.0605962 9.17711 -0.0605961 9.57285 0.18349 9.81694C0.427576 10.061 0.823317 10.061 1.0674 9.81694L5.00015 5.88418L8.9329 9.81694C9.17699 10.061 9.57273 10.061 9.81682 9.81694C10.0609 9.57285 10.0609 9.17711 9.81682 8.93302L5.88359 4.99979L9.81639 1.06698C10.0605 0.822892 10.0605 0.42715 9.81639 0.183064C9.57231 -0.0610215 9.17657 -0.0610214 8.93248 0.183065L4.99973 4.11582L1.06698 0.183065Z"
                                                fill="currentcolor" />
                                        </svg>
                                    </button>
                                    <!-- <button class="btn btn-scan btn-view">
                                        <div class="svg-wrap">
                                            <svg width="21" height="21" viewBox="0 0 21 21" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M0 9.33333V0H9.33333V9.33333H0ZM3.5 3.5V5.83333H5.83333V3.5H3.5ZM11.6667 9.33333V0H21V9.33333H11.6667ZM15.1667 3.5V5.83333H17.5V3.5H15.1667ZM0 11.6667V21H9.33333V11.6667H0ZM5.83333 15.1667V17.5H3.5V15.1667H5.83333ZM15.1667 11.6667H11.6667V14H15.1667V18.6667H14V16.3333H11.6667V21H16.3333V18.6667H18.6667V21H21V17.5H18.6667V16.3333H17.5V15.1667H21V11.6667H17.5V14H15.1667V11.6667Z"
                                                    fill="currentcolor" />
                                            </svg>
                                        </div>
                                    </button> -->
                                    <div ngbDropdown placement="bottom-end" #myDrop="ngbDropdown" class="f-drop-wrap">
                                        <button class="btn btn-filter btn-view" id="dropdown-filter" ngbDropdownToggle
                                            #dropdownToggle>
                                            <div class="svg-wrap mod-svg-wrap">
                                                <svg width="23" height="23" viewBox="0 0 23 23" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M1.05485 2.10499C0.828945 2.10499 0.603042 2.18919 0.420168 2.32601C-0.0531511 2.68386 -0.139209 3.34693 0.226538 3.7995V3.81003L5.93864 10.967V17.2714L8.40206 19.6921C8.82159 20.1026 9.51005 20.1026 9.92959 19.6921C10.3491 19.2817 10.3491 18.6081 9.92959 18.1976L8.0901 16.4084V10.2408L1.92619 2.51546C1.8232 2.38586 1.69094 2.28136 1.53977 2.21014C1.38859 2.13893 1.22262 2.10293 1.05485 2.10499ZM14.5445 9.47244V17.7661C14.5875 18.0818 14.4799 18.4186 14.2325 18.6397C14.133 18.7372 14.0148 18.8146 13.8846 18.8674C13.7545 18.9203 13.615 18.9474 13.4741 18.9474C13.3332 18.9474 13.1937 18.9203 13.0636 18.8674C12.9334 18.8146 12.8152 18.7372 12.7157 18.6397L10.5535 16.5241C10.4362 16.4119 10.347 16.2747 10.2929 16.1231C10.2387 15.9716 10.2212 15.8099 10.2415 15.6506V9.47244H10.2093L4.01309 1.70504C3.8384 1.48563 3.75958 1.20748 3.79385 0.931383C3.82811 0.655284 3.97268 0.40368 4.19597 0.231549C4.40036 0.0841995 4.62626 0 4.86292 0H19.9231C20.1597 0 20.3856 0.0841995 20.59 0.231549C20.8133 0.40368 20.9579 0.655284 20.9922 0.931383C21.0264 1.20748 20.9476 1.48563 20.7729 1.70504L14.5767 9.47244H14.5445Z"
                                                        fill="currentcolor" />
                                                    <circle cx="17" cy="17" r="6" fill="#FAF8FA" />
                                                    <path d="M13 16H16V13H18V16H21V18H18V21H16V18H13V16Z"
                                                        fill="#AE77A0" />
                                                </svg>
                                            </div>
                                        </button>
                                        <div ngbDropdownMenu aria-labelledby="dropdown-filter" class="filter-dropdown"
                                            #filterDropdownMenu>
                                            <div class="filter-chips-wrap d-none d-md-flex">
                                                <div class="chips-inner">
                                                    <div class="chip">
                                                        <span>Lunch</span>
                                                        <button class="btn">
                                                            <img src="./assets/images/ic-close.svg" alt="Icon">
                                                        </button>
                                                    </div>
                                                    <div class="chip">
                                                        <span>Breakfast</span>
                                                        <button class="btn">
                                                            <img src="./assets/images/ic-close.svg" alt="Icon">
                                                        </button>
                                                    </div>
                                                    <div class="chip">
                                                        <span>Dinner</span>
                                                        <button class="btn">
                                                            <img src="./assets/images/ic-close.svg" alt="Icon">
                                                        </button>
                                                    </div>
                                                    <div class="chip">
                                                        <span>Supper</span>
                                                        <button class="btn">
                                                            <img src="./assets/images/ic-close.svg" alt="Icon">
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="tab-wrapper">
                                                <div ngbNav #nav="ngbNav" [(activeId)]="active"
                                                    class="nav-pills outer-tabs">
                                                    <ng-container ngbNavItem="place">
                                                        <button ngbNavLink>Place</button>
                                                        <ng-template ngbNavContent>
                                                            <div class="inner-tab-block">
                                                                <div ngbNav #nav="ngbNav" [(activeId)]="activeInner"
                                                                    class="nav-tabs">
                                                                    <ng-container ngbNavItem="by-rating">
                                                                        <button ngbNavLink>
                                                                            <img src="./assets/images/ic-tab-arrow.svg"
                                                                                alt="Icon" />
                                                                            By Rating
                                                                        </button>
                                                                        <ng-template ngbNavContent>
                                                                            <p>By Rating Content</p>
                                                                        </ng-template>
                                                                    </ng-container>
                                                                    <ng-container ngbNavItem="price-range">
                                                                        <button ngbNavLink>
                                                                            <img src="./assets/images/ic-tab-arrow.svg"
                                                                                alt="Icon" />
                                                                            Price Range
                                                                        </button>
                                                                        <ng-template ngbNavContent>
                                                                            <p>Price Range Content</p>
                                                                        </ng-template>
                                                                    </ng-container>
                                                                    <ng-container ngbNavItem="type-of-meal">
                                                                        <button ngbNavLink>
                                                                            <img src="./assets/images/ic-tab-arrow.svg"
                                                                                alt="Icon" />
                                                                            Type of Meal
                                                                        </button>
                                                                        <ng-template ngbNavContent>
                                                                            <div class="checkbox-wrap-row">
                                                                                <div class="row">
                                                                                    <div class="col-4 col-md-6">
                                                                                        <div class="form-check">
                                                                                            <input type="checkbox"
                                                                                                class="form-check-input"
                                                                                                id="breakfastCheck"
                                                                                                checked />
                                                                                            <label
                                                                                                class="form-check-label"
                                                                                                for="breakfastCheck">
                                                                                                Breakfast
                                                                                            </label>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div class="col-4 col-md-6">
                                                                                        <div class="form-check">
                                                                                            <input type="checkbox"
                                                                                                class="form-check-input"
                                                                                                id="supperCheck" />
                                                                                            <label
                                                                                                class="form-check-label"
                                                                                                for="supperCheck">
                                                                                                Supper
                                                                                            </label>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div class="col-12">
                                                                                        <div class="form-check">
                                                                                            <input type="checkbox"
                                                                                                class="form-check-input"
                                                                                                id="lunchCheck" />
                                                                                            <label
                                                                                                class="form-check-label"
                                                                                                for="lunchCheck">
                                                                                                Lunch
                                                                                            </label>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div class="col-12">
                                                                                        <div class="form-check">
                                                                                            <input type="checkbox"
                                                                                                class="form-check-input"
                                                                                                id="dinnerCheck" />
                                                                                            <label
                                                                                                class="form-check-label"
                                                                                                for="dinnerCheck">
                                                                                                Dinner
                                                                                            </label>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </ng-template>
                                                                    </ng-container>
                                                                </div>

                                                                <div [ngbNavOutlet]="nav"></div>
                                                            </div>
                                                        </ng-template>
                                                    </ng-container>
                                                    <ng-container ngbNavItem="categories">
                                                        <button ngbNavLink>Categories</button>
                                                        <ng-template ngbNavContent>
                                                            <div class="inner-tab-block">
                                                                <div ngbNav #nav="ngbNav" [(activeId)]="activeInner"
                                                                    class="nav-tabs">
                                                                    <ng-container ngbNavItem="type-of-meal">
                                                                        <button ngbNavLink>
                                                                            <img src="./assets/images/ic-tab-arrow.svg"
                                                                                alt="Icon" />
                                                                            Type of Meal
                                                                        </button>
                                                                        <ng-template ngbNavContent>
                                                                            <div class="checkbox-wrap-row">
                                                                                <div class="row">
                                                                                    <div class="col-4 col-md-6">
                                                                                        <div class="form-check">
                                                                                            <input type="checkbox"
                                                                                                class="form-check-input"
                                                                                                id="breakfastCheck"
                                                                                                checked />
                                                                                            <label
                                                                                                class="form-check-label"
                                                                                                for="breakfastCheck">
                                                                                                Breakfast
                                                                                            </label>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div class="col-4 col-md-6">
                                                                                        <div class="form-check">
                                                                                            <input type="checkbox"
                                                                                                class="form-check-input"
                                                                                                id="supperCheck" />
                                                                                            <label
                                                                                                class="form-check-label"
                                                                                                for="supperCheck">
                                                                                                Supper
                                                                                            </label>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div class="col-12">
                                                                                        <div class="form-check">
                                                                                            <input type="checkbox"
                                                                                                class="form-check-input"
                                                                                                id="lunchCheck" />
                                                                                            <label
                                                                                                class="form-check-label"
                                                                                                for="lunchCheck">
                                                                                                Lunch
                                                                                            </label>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div class="col-12">
                                                                                        <div class="form-check">
                                                                                            <input type="checkbox"
                                                                                                class="form-check-input"
                                                                                                id="dinnerCheck" />
                                                                                            <label
                                                                                                class="form-check-label"
                                                                                                for="dinnerCheck">
                                                                                                Dinner
                                                                                            </label>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </ng-template>
                                                                    </ng-container>
                                                                </div>
                                                                <div [ngbNavOutlet]="nav"></div>
                                                            </div>
                                                        </ng-template>
                                                    </ng-container>
                                                    <ng-container ngbNavItem="articles">
                                                        <button ngbNavLink style="margin-left: auto; margin-right: 0;"
                                                            class="article-d-link">Articles</button>
                                                        <ng-template ngbNavContent>
                                                            <div class="inner-tab-block">
                                                                <div class="arti-tab-block datepicker-view-active">
                                                                    <div class="aside-block">
                                                                        <button class="btn btn-text" title="Date">
                                                                            <img src="./assets/images/ic-tab-arrow.svg"
                                                                                alt="Icon" />
                                                                            Date
                                                                        </button>
                                                                        <button class="btn btn-text" title="Category">
                                                                            <img src="./assets/images/ic-tab-arrow.svg"
                                                                                alt="Icon" />
                                                                            Category
                                                                        </button>
                                                                        <button class="btn btn-text"
                                                                            title=" Created By">
                                                                            <img src="./assets/images/ic-tab-arrow.svg"
                                                                                alt="Icon" />
                                                                            Created By
                                                                        </button>
                                                                    </div>
                                                                    <div class="arti-data-block">
                                                                        <ul>
                                                                            <li class="date-li">
                                                                                <div class="date-form-block">
                                                                                    <p>18 Dec, 2018</p>
                                                                                    &nbsp;
                                                                                    -
                                                                                    &nbsp;
                                                                                    <p>28 Dec, 2018</p>
                                                                                </div>
                                                                            </li>
                                                                            <li class="category-li">
                                                                                <h5><span>Entertainment</span></h5>
                                                                            </li>
                                                                            <li>
                                                                                <h5>Viren Patel</h5>
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                    <div class="date-picker-layer d-none">
                                                                        <div class="datepicker-grp-base">
                                                                            <ngb-datepicker #dp [(ngModel)]="model" />
                                                                        </div>
                                                                    </div>
                                                                    <ul class="category-ul-layer d-none">
                                                                        <li>
                                                                            <div class="form-check">
                                                                                <input class="form-check-input"
                                                                                    type="checkbox" id="check-1">
                                                                                <label class="form-check-label"
                                                                                    for="check-1">
                                                                                    Entertainment
                                                                                </label>
                                                                            </div>
                                                                        </li>
                                                                        <li>
                                                                            <div class="form-check">
                                                                                <input class="form-check-input"
                                                                                    type="checkbox" id="check-2">
                                                                                <label class="form-check-label"
                                                                                    for="check-2">
                                                                                    Health
                                                                                </label>
                                                                            </div>
                                                                        </li>
                                                                        <li>
                                                                            <div class="form-check">
                                                                                <input class="form-check-input"
                                                                                    type="checkbox" id="check-3">
                                                                                <label class="form-check-label"
                                                                                    for="check-3">
                                                                                    Gaming
                                                                                </label>
                                                                            </div>
                                                                        </li>
                                                                        <li>
                                                                            <div class="form-check">
                                                                                <input class="form-check-input"
                                                                                    type="checkbox" id="check-4">
                                                                                <label class="form-check-label"
                                                                                    for="check-4">
                                                                                    Lifestyle
                                                                                </label>
                                                                            </div>
                                                                        </li>
                                                                    </ul>
                                                                    <div class="created-by-layer d-none">
                                                                        <div class="multi-select-wrap">
                                                                            <ng-select [(ngModel)]="typeSelect"
                                                                                class="ng-form-select primary-select">
                                                                                <ng-option *ngFor="let type of types"
                                                                                    [value]="type.id">{{type.name}}</ng-option>
                                                                            </ng-select>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </ng-template>
                                                    </ng-container>
                                                </div>
                                                <div [ngbNavOutlet]="nav" class="outer-tab-content"></div>
                                            </div>
                                            <div class="filter-chips-wrap d-md-none">
                                                <div class="chips-inner">
                                                    <div class="chip">
                                                        <span>Lunch</span>
                                                        <button class="btn">
                                                            <img src="./assets/images/ic-close.svg" alt="Icon">
                                                        </button>
                                                    </div>
                                                    <div class="chip">
                                                        <span>Breakfast</span>
                                                        <button class="btn">
                                                            <img src="./assets/images/ic-close.svg" alt="Icon">
                                                        </button>
                                                    </div>
                                                    <div class="chip">
                                                        <span>Dinner</span>
                                                        <button class="btn">
                                                            <img src="./assets/images/ic-close.svg" alt="Icon">
                                                        </button>
                                                    </div>
                                                    <div class="chip">
                                                        <span>Supper</span>
                                                        <button class="btn">
                                                            <img src="./assets/images/ic-close.svg" alt="Icon">
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="cta-btn-wrap d-md-none">
                                                <button class="btn btn-outline-primary with-icon">
                                                    <div class="svg-wrap">
                                                        <svg width="12" height="14" viewBox="0 0 12 14" fill="none"
                                                            xmlns="http://www.w3.org/2000/svg">
                                                            <path
                                                                d="M6 0C7.5913 0 9.11742 0.632141 10.2426 1.75736C11.3679 2.88258 12 4.4087 12 6C12 8.484 10.1067 11.0867 6.4 13.8667C6.2846 13.9532 6.14425 14 6 14C5.85575 14 5.7154 13.9532 5.6 13.8667C1.89333 11.0867 0 8.484 0 6C0 4.4087 0.632141 2.88258 1.75736 1.75736C2.88258 0.632141 4.4087 0 6 0ZM6 4C5.46957 4 4.96086 4.21071 4.58579 4.58579C4.21071 4.96086 4 5.46957 4 6C4 6.53043 4.21071 7.03914 4.58579 7.41421C4.96086 7.78929 5.46957 8 6 8C6.53043 8 7.03914 7.78929 7.41421 7.41421C7.78929 7.03914 8 6.53043 8 6C8 5.46957 7.78929 4.96086 7.41421 4.58579C7.03914 4.21071 6.53043 4 6 4Z"
                                                                fill="currentcolor" />
                                                        </svg>
                                                    </div>
                                                    Sydney
                                                </button>
                                                <button class="btn btn-outline-primary">Open</button>
                                                <button class="btn btn-outline-primary" disabled>
                                                    Closeby
                                                </button>
                                                <button class="btn btn-outline-primary with-icon" disabled>
                                                    <div class="svg-wrap">
                                                        <svg width="13" height="13" viewBox="0 0 13 13" fill="none"
                                                            xmlns="http://www.w3.org/2000/svg">
                                                            <path
                                                                d="M0 5.77778V0H5.77778V5.77778H0ZM2.16667 2.16667V3.61111H3.61111V2.16667H2.16667ZM7.22222 5.77778V0H13V5.77778H7.22222ZM9.38889 2.16667V3.61111H10.8333V2.16667H9.38889ZM0 7.22222V13H5.77778V7.22222H0ZM3.61111 9.38889V10.8333H2.16667V9.38889H3.61111ZM9.38889 7.22222H7.22222V8.66667H9.38889V11.5556H8.66667V10.1111H7.22222V13H10.1111V11.5556H11.5556V13H13V10.8333H11.5556V10.1111H10.8333V9.38889H13V7.22222H10.8333V8.66667H9.38889V7.22222Z"
                                                                fill="currentcolor" />
                                                        </svg>
                                                    </div>
                                                    Scan
                                                </button>
                                            </div>
                                        </div>
                                        <!-- New Dropdown Added Here -->
                                        <!-- <div ngbDropdownMenu aria-labelledby="filter-drop"
                                            class="article-filter-menu for-home">
                                            <div class="dropdown-head">
                                                <h4 class="drop-title">Filter</h4>
                                                <button class="btn btn-close"
                                                    (click)="$event.stopPropagation(); myDrop.close()"></button>
                                            </div>
                                            <div class="dropdown-body">
                                                <div class="row">
                                                    <div class="col-12">
                                                        <label class="data-label">First Name</label>
                                                        <input type="text" class="form-control" placeholder="First Name">
                                                    </div>
                                                    <div class="col-12 col-sm-6">
                                                        <label class="data-label">First Name</label>
                                                        <input type="text" class="form-control" placeholder="First Name">
                                                    </div>
                                                    <div class="col-12 col-sm-6">
                                                        <label class="data-label">First Name</label>
                                                        <input type="text" class="form-control" placeholder="First Name">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="dropdown-footer">
                                                <div class="btn-grps">
                                                    <button class="btn btn-outline-danger" title="Clear All">Clear
                                                        All</button>
                                                    <button class="btn btn-primary" title="Apply">Apply</button>
                                                </div>
                                            </div>
                                        </div> -->
                                    </div>
                                    <!-- <button class="btn btn-view-text d-none d-md-flex" title="Open">
                                        Open
                                    </button>
                                    <button class="btn btn-view-text d-none d-md-flex" title="Closeby" disabled>
                                        Closeby
                                    </button> -->
                                    <button class="btn btn-view btn-search" (click)="viewSearchBar()">
                                        <div class="svg-wrap" style="margin-top: 1px;">
                                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M13 13L10.1667 10.1617L13 13ZM11.7368 6.36842C11.7368 7.79221 11.1712 9.15769 10.1645 10.1645C9.15769 11.1712 7.79221 11.7368 6.36842 11.7368C4.94463 11.7368 3.57915 11.1712 2.57237 10.1645C1.5656 9.15769 1 7.79221 1 6.36842C1 4.94463 1.5656 3.57915 2.57237 2.57237C3.57915 1.5656 4.94463 1 6.36842 1C7.79221 1 9.15769 1.5656 10.1645 2.57237C11.1712 3.57915 11.7368 4.94463 11.7368 6.36842V6.36842Z"
                                                    stroke="currentcolor" stroke-width="2" stroke-linecap="round" />
                                            </svg>
                                        </div>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="masonry-wrapper-outer">
                        <!-- <div class="no-articles-found-wrap">
                            <img src="./assets/images/no-articles-found.svg" alt="Icon">
                            <h3>No articles found</h3>
                            <p>No articles found. Explore the latest in craft beer, artisanal cuisine, and culinary
                                trends in our flavorful journey
                                ahead!
                            </p>
                        </div> -->
                        <ngx-masonry [options]="masonryOptions" class="masonry-wrapper">
                            <div ngxMasonryItem class="masonry-item">
                                <div class="card hero-card" (click)="openViewArticleModal(viewArticleModal)">
                                    <div class="card-head">
                                        <h4 class="card-title">
                                            Artisan iceland
                                            <img src="./assets/images/ic-fire.svg" alt="Icon" />
                                        </h4>
                                    </div>
                                    <div class="card-body">
                                        <p class="food-info">
                                            Craft beer asymmetrical glossier ananas plant thundercats
                                            normcore marfa small batch
                                        </p>
                                        <div class="gallery-view two-by-two mb-0">
                                            <div class="row">
                                                <div class="col-6">
                                                    <img src="./assets/images/pizza-1.png" alt="Pizza" />
                                                </div>
                                                <div class="col-6">
                                                    <img src="./assets/images/pizza-2.png" alt="Pizza" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div ngxMasonryItem class="masonry-item">
                                <div class="card hero-card">
                                    <div class="card-head">
                                        <h4 class="card-title">
                                            Cake romne strate beaver
                                            <img src="./assets/images/ic-fire.svg" alt="Icon" />
                                        </h4>
                                    </div>
                                    <div class="card-body">
                                        <p class="food-info">
                                            Selvage pinterest shaman, asymmetrical glossier intelligentsia
                                        </p>
                                        <div class="gallery-view three-by-two">
                                            <div class="row">
                                                <div class="col-4">
                                                    <img src="./assets/images/cake-1.png" alt="Cake" />
                                                </div>
                                                <div class="col-4">
                                                    <img src="./assets/images/cake-2.png" alt="Cake" />
                                                </div>
                                                <div class="col-4">
                                                    <img src="./assets/images/cake-3.png" alt="Cake" />
                                                </div>
                                            </div>
                                        </div>
                                        <p class="food-info">
                                            Yronic delly keffiyeh actually pour-over affogato whatever
                                            ethical everyday carry locavore poutine yuccie cred try-hard.
                                            Subway tile wayfarers leggings
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div ngxMasonryItem class="masonry-item">
                                <div class="card hero-card">
                                    <div class="gallery-view mt-0">
                                        <div class="row">
                                            <div class="col-12">
                                                <img src="./assets/images/toast-1.png" alt="Toast" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card-head">
                                        <h4 class="card-title">
                                            Tortuga lamber ren
                                            <img src="./assets/images/ic-leaf.svg" alt="Icon" />
                                        </h4>
                                    </div>
                                    <div class="card-body">
                                        <p class="food-info mb-10px">
                                            Plaid ethical four dollar toast gochujang, letterpress
                                            adaptogen glossier ananas plant thundercats normcore
                                        </p>
                                        <p class="food-info">
                                            Selvage pinterest shaman, asymmetrical glossier intelligentsia
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div ngxMasonryItem class="masonry-item">
                                <div class="card hero-card">
                                    <div class="gallery-view mt-0">
                                        <div class="row">
                                            <div class="col-12">
                                                <img src="./assets/images/toast-2.png" alt="Toast" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card-head">
                                        <h4 class="card-title">
                                            Pour-over chia offal
                                            <img src="./assets/images/ic-leaf.svg" alt="Icon" />
                                        </h4>
                                    </div>
                                    <div class="card-body">
                                        <p class="food-info">
                                            Plaid ethical four dollar toast gochujang, letterpress
                                            adaptogen glossier ananas plant thundercats normcore
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div ngxMasonryItem class="masonry-item">
                                <div class="card hero-card">
                                    <div class="card-head">
                                        <ul class="user-list">
                                            <li>
                                                <img src="./assets/images/user-1.jpg" alt="User" />
                                            </li>
                                            <li>
                                                <img src="./assets/images/user-2.jpg" alt="User" />
                                            </li>
                                            <li>
                                                <img src="./assets/images/user-3.jpg" alt="User" />
                                            </li>
                                        </ul>

                                        <h4 class="card-title">
                                            Emma Peters Group
                                            <img src="./assets/images/ic-fire.svg" alt="Icon" />
                                        </h4>
                                    </div>
                                    <div class="card-body">
                                        <p class="food-info">
                                            Craft beer asymmetrical glossier ananas plant thundercats
                                            normcore marfa small batch
                                        </p>
                                        <div class="current-benefit">
                                            <a href="#" class="deal">Pasta Special <span class="text">Deal</span>
                                                <span class="icon"><img src="./assets/images/ic-arrow-tr.svg"
                                                        alt="Icon" /></span>
                                            </a>
                                        </div>
                                        <div class="gallery-view">
                                            <div class="row">
                                                <div class="col-12">
                                                    <img src="./assets/images/pasta-1.png" alt="Pasta" />
                                                </div>
                                            </div>
                                        </div>
                                        <p class="food-info">
                                            Find one asymmetrical glossier ananas plant thundercats
                                            normcore marfa small batch thundercats mumblecore bushwick
                                            four dollar toast everyday carry swag live-edge chicharrones.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div ngxMasonryItem class="masonry-item">
                                <div class="card hero-card">
                                    <div class="card-head">
                                        <ul class="food-story">
                                            <li>
                                                <img src="./assets/images/buritto-1.png" alt="Buritto" />
                                                <span class="bg-span"></span>
                                            </li>
                                            <li>
                                                <img src="./assets/images/hot-dog-1.png" alt="Hot Dog" />
                                                <span class="bg-span"></span>
                                            </li>
                                        </ul>
                                        <h4 class="card-title">
                                            Boun rastorne havere
                                            <img src="./assets/images/ic-fire.svg" alt="Icon" />
                                        </h4>
                                    </div>
                                    <div class="card-body">
                                        <p class="food-info">
                                            Craft beer asymmetrical glossier ananas plant thundercats
                                            normcore marfa small batch
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </ngx-masonry>

                        <!-- For Loader Use Below -->
                        <!-- <ngx-masonry [options]="masonryOptions" class="masonry-wrapper">
                            <div ngxMasonryItem class="masonry-item">
                                <div class="card hero-card"
                                    style="background-color: transparent;box-shadow: none;border: 0;">
                                    <div class="item">
                                        <div style="width: 40%;">
                                            <ngx-skeleton-loader [theme]="{height: '16px'}" />
                                        </div>
                                        <ngx-skeleton-loader [theme]="{height: '16px'}" />
                                        <ngx-skeleton-loader [theme]="{height: '16px'}" />
                                        <div class="d-flex" style="gap: 10px;">
                                            <div style="width: 50%;">
                                                <ngx-skeleton-loader [theme]="{height: '82px', borderRadius: '10px'}" />
                                            </div>
                                            <div style="width: 50%;">
                                                <ngx-skeleton-loader [theme]="{height: '82px', borderRadius: '10px'}" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div ngxMasonryItem class="masonry-item">
                                <div class="card hero-card"
                                    style="background-color: transparent;box-shadow: none;border: 0;">
                                    <div class="item">
                                        <div style="width: 70%;">
                                            <ngx-skeleton-loader [theme]="{height: '16px'}" />
                                        </div>
                                        <ngx-skeleton-loader [theme]="{height: '16px'}" />
                                        <ngx-skeleton-loader [theme]="{height: '16px'}" />
                                        <div class="d-flex" style="gap: 10px;">
                                            <div style="width: 33.3%;">
                                                <ngx-skeleton-loader [theme]="{height: '58px', borderRadius: '10px'}" />
                                            </div>
                                            <div style="width: 33.3%;">
                                                <ngx-skeleton-loader [theme]="{height: '58px', borderRadius: '10px'}" />
                                            </div>
                                            <div style="width: 33.3%;">
                                                <ngx-skeleton-loader [theme]="{height: '58px', borderRadius: '10px'}" />
                                            </div>
                                        </div>
                                        <ngx-skeleton-loader [theme]="{height: '16px'}" />
                                        <ngx-skeleton-loader [theme]="{height: '16px'}" />
                                    </div>
                                </div>
                            </div>
                            <div ngxMasonryItem class="masonry-item">
                                <div class="card hero-card"
                                    style="background-color: transparent;box-shadow: none;border: 0;">
                                    <div class="item">
                                        <div>
                                            <ngx-skeleton-loader [theme]="{height: '170px', borderRadius: '10px'}" />
                                        </div>
                                        <div style="width: 70%;">
                                            <ngx-skeleton-loader [theme]="{height: '16px'}" />
                                        </div>
                                        <ngx-skeleton-loader [theme]="{height: '16px'}" />
                                        <ngx-skeleton-loader [theme]="{height: '16px'}" />
                                    </div>
                                </div>
                            </div>
                            <div ngxMasonryItem class="masonry-item">
                                <div class="card hero-card"
                                    style="background-color: transparent;box-shadow: none;border: 0;">
                                    <div class="item">
                                        <div style="width: 70%;">
                                            <ngx-skeleton-loader [theme]="{height: '16px'}" />
                                        </div>
                                        <ngx-skeleton-loader [theme]="{height: '16px'}" />
                                        <ngx-skeleton-loader [theme]="{height: '16px'}" />
                                        <div class="d-flex" style="gap: 10px;">
                                            <div style="width: 33.3%;">
                                                <ngx-skeleton-loader [theme]="{height: '58px', borderRadius: '10px'}" />
                                            </div>
                                            <div style="width: 33.3%;">
                                                <ngx-skeleton-loader [theme]="{height: '58px', borderRadius: '10px'}" />
                                            </div>
                                            <div style="width: 33.3%;">
                                                <ngx-skeleton-loader [theme]="{height: '58px', borderRadius: '10px'}" />
                                            </div>
                                        </div>
                                        <ngx-skeleton-loader [theme]="{height: '16px'}" />
                                        <ngx-skeleton-loader [theme]="{height: '16px'}" />
                                    </div>
                                </div>
                            </div>
                            <div ngxMasonryItem class="masonry-item">
                                <div class="card hero-card"
                                    style="background-color: transparent;box-shadow: none;border: 0;">
                                    <div class="item">
                                        <div>
                                            <ngx-skeleton-loader [theme]="{height: '170px', borderRadius: '10px'}" />
                                        </div>
                                        <div style="width: 70%;">
                                            <ngx-skeleton-loader [theme]="{height: '16px'}" />
                                        </div>
                                        <ngx-skeleton-loader [theme]="{height: '16px'}" />
                                        <ngx-skeleton-loader [theme]="{height: '16px'}" />
                                    </div>
                                </div>
                            </div>
                            <div ngxMasonryItem class="masonry-item">
                                <div class="card hero-card"
                                    style="background-color: transparent;box-shadow: none;border: 0;">
                                    <div class="item">
                                        <div style="width: 40%;">
                                            <ngx-skeleton-loader [theme]="{height: '16px'}" />
                                        </div>
                                        <ngx-skeleton-loader [theme]="{height: '16px'}" />
                                        <ngx-skeleton-loader [theme]="{height: '16px'}" />
                                        <div class="d-flex" style="gap: 10px;">
                                            <div style="width: 50%;">
                                                <ngx-skeleton-loader [theme]="{height: '82px', borderRadius: '10px'}" />
                                            </div>
                                            <div style="width: 50%;">
                                                <ngx-skeleton-loader [theme]="{height: '82px', borderRadius: '10px'}" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ngx-masonry> -->
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>
<app-ui-loader class="d-none"></app-ui-loader>

<!-- Login Modal modal -->
<ng-template #viewArticleModal let-modal>
    <div class="modal-header">
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"
            title="Close Modal"></button>
    </div>
    <div class="modal-body">
        <h5 class="modal-info-text">Glad to see you back!</h5>
    </div>
</ng-template>